import type { DirectDepositCreateRequestData } from '#src/interfaces/directDepositCreateRequestData'
import type { DirectDepositsConfig } from '#src/interfaces/directDepositsConfig'
import type { DirectDepositsTransactionsParams } from '#src/interfaces/directDepositsTransactionsParams'
import type { DirectDepositsPlayerData } from '#src/interfaces/directDepositsPlayerData'
import type { DirectDepositTransaction } from '#src/interfaces/directDepositTransaction'
import type { DirectDepositsTransactionsResponse } from '#src/interfaces/directDepositsTransactionsResponse'
import directDepositsApiInstance from './directDepositsApiClient'

const getDirectDepositsConfig = async (tenantId: string) =>
  directDepositsApiInstance.get<DirectDepositsConfig>(`/tenants/${tenantId}/config`)

const getDirectDepositsTransactions = async (
  tenantId: string,
  params: DirectDepositsTransactionsParams
) =>
  directDepositsApiInstance.get<DirectDepositsTransactionsResponse>(
    `/tenants/${tenantId}/transactions`,
    {
      params
    }
  )

const createDirectDeposit = async (tenantId: string, data: DirectDepositCreateRequestData) =>
  directDepositsApiInstance.post<DirectDepositTransaction>(`/tenants/${tenantId}/deposits`, data)

const getDirectDepositsPlayerData = async (tenantId: string, playerSearchTerm: string) =>
  directDepositsApiInstance.get<DirectDepositsPlayerData>(`/tenants/${tenantId}/players`, {
    params: { playerSearchTerm }
  })

export {
  getDirectDepositsConfig,
  getDirectDepositsTransactions,
  createDirectDeposit,
  getDirectDepositsPlayerData
}
